import { render, staticRenderFns } from "./InputMultiple.vue?vue&type=template&id=5b2e4600&lang=html&"
import script from "./InputMultiple.vue?vue&type=script&lang=js&"
export * from "./InputMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports